import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  "data-testid": "cargo-v2-rtc-modal-plane-auto",
  style: {"width":"33rem","max-width":"80vw","max-height":"80vh"},
  class: "relative edit-body overflow-y-auto h-full"
}
const _hoisted_2 = { class: "gap-x-3 px-6 pb-6 pt-4 flex justify-center flex-col" }
const _hoisted_3 = {
  key: 0,
  class: "px-4 py-3 mb-6 bg-blue-lp-600 rounded-lg flex-col justify-center items-start gap-2.5 inline-flex"
}
const _hoisted_4 = { class: "justify-start items-center gap-3 inline-flex" }
const _hoisted_5 = { class: "grow shrink basis-0" }
const _hoisted_6 = { class: "text-blue-lp-500 text-xs font-normal font-['Montserrat']" }
const _hoisted_7 = { class: "text-blue-lp-500 text-xs font-bold font-['Montserrat']" }
const _hoisted_8 = {
  key: 0,
  "data-testid": "cargo-v2-rtc-modal-error-nog",
  class: "text-red-lp-2000 text-sm"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "my-6" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "dialog-airport",
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = $event)),
    title: _ctx.$t('cargoV2.components.common.completeBookingData'),
    persistent: "",
    customBody: "py-3",
    onReset: _ctx.onReset,
    showOverflow: ""
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (
            _ctx.rtcData.cargoType === 'plane' &&
              !_ctx.rtcData.cutOffTimeExceededWithoutNextConfig
          )
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_Icons, {
                    name: "info",
                    class: "w-5 text-blue-lp-500"
                  }),
                  _createVNode("div", _hoisted_5, [
                    _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("cargoV2.components.cardRtc.departureStart")), 1),
                    _createVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDateVal), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_DataWrapper, {
            class: "my-2",
            label: _ctx.$t('cargoV2.components.modalPlaneAuto.commodityGroup'),
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomDropdown, {
                class: "w-full",
                placeholder: _ctx.$t('cargoV2.components.common.selectCommodity'),
                options: _ctx.commodityOptions,
                onSelect: _ctx.onSelectCommodity,
                selectedItem: _ctx.commodityItem,
                isCustomWidth: "",
                isDisabled: _ctx.disableCommodityGroup
              }, null, 8, ["placeholder", "options", "onSelect", "selectedItem", "isDisabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('cargoV2.components.modalPlaneAuto.productType'),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Select, {
                onOpenSelect: _ctx.onOpenSelectCargoProduct,
                onCloseSelect: _ctx.onCloseSelectCargoProduct,
                isOpenMenu: _ctx.isOpenSelectCargoProduct,
                value: _ctx.form.productCargo,
                onChooseSelect: _ctx.onSelectCargoProduct,
                dataSelect: _ctx.listProductCargo,
                customClass: "w-full",
                class: "w-full whitespace-no-wrap my-2 z-10"
              }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('cargoV2.components.common.nog'),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                "data-testid": "cargo-v2-rtc-modal-input-nog",
                onChange: _ctx.onChangeNog,
                modelValue: _ctx.form.nog,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.nog = $event)),
                placeholder: _ctx.$t('cargoV2.components.common.inputNog'),
                error: _ctx.isNogError,
                isErrorIconCaption: false
              }, null, 8, ["onChange", "modelValue", "placeholder", "error"]),
              (_ctx.isNogError)
                ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("cargo.v2.nog.error.required")), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('cargoV2.components.common.shc'),
            optional: "",
            class: "flex-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomDropdown, {
                class: "w-full",
                placeholder: _ctx.$t('cargoV2.components.common.selectShc'),
                options: _ctx.listShc,
                onSelect: _ctx.onSelectShc,
                selectedItem: _ctx.shcItem,
                isCustomWidth: "",
                isDisabled: _ctx.listShc.length === 1,
                disableBackground: _ctx.listShc.length === 1
              }, null, 8, ["placeholder", "options", "onSelect", "selectedItem", "isDisabled", "disableBackground"])
            ]),
            _: 1
          }, 8, ["label"]),
          _hoisted_9,
          _createVNode(_component_lp_button, {
            "data-testid": "cargo-v2-rtc-modal-button-submit",
            textColor: "white",
            title: _ctx.submitTitle,
            fontWeight: "semibold",
            color: "red-lp-100",
            isWidthFull: "",
            customClass: "py-2 px-8",
            onClick: _ctx.onSubmit,
            disabled: _ctx.isSubmitDisabled
          }, null, 8, ["title", "onClick", "disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onReset"]))
}